export const virtualAssistantAnimations = {
    congratulate: 'Congratulate',
    lookRight: 'LookRight',
    sendMail: 'SendMail',
    thinking: 'Thinking',
    explain: 'Explain',
    idleRopePile: 'IdleRopePile',
    idleAtom: 'IdleAtom',
    print: 'Print',
    hide: 'Hide',
    getAttention: 'GetAttention',
    save: 'Save',
    getTechy: 'GetTechy',
    gestureUp: 'GestureUp',
    idle1_1: 'Idle1_1',
    processing: 'Processing',
    alert: 'Alert',
    lookUpRight: 'LookUpRight',
    idleSideToSide: 'IdleSideToSide',
    goodBye: 'GoodBye',
    lookLeft: 'LookLeft',
    idleHeadScratch: 'IdleHeadScratch',
    lookUpLeft: 'LookUpLeft',
    checkingSomething: 'CheckingSomething',
    hearing_1: 'Hearing_1',
    getWizardy: 'GetWizardy',
    idleFingerTap: 'IdleFingerTap',
    gestureLeft: 'GestureLeft',
    wave: 'Wave',
    gestureRight: 'GestureRight',
    writing: 'Writing',
    idleSnooze: 'IdleSnooze',
    lookDownRight: 'LookDownRight',
    getArtsy: 'GetArtsy',
    show: 'Show',
    lookDown: 'LookDown',
    searching: 'Searching',
    emptyTrash: 'EmptyTrash',
    greeting: 'Greeting',
    lookUp: 'LookUp',
    gestureDown: 'GestureDown',
    restPose: 'RestPose',
    idleEyeBrowRaise: 'IdleEyeBrowRaise',
    lookDownLeft: 'LookDownLeft',
};
